import notificationApi from "../apis/notificationApi";

export default {
    namespaced: true,
    state: {
        isLoading: false,
        isSaving: false,
        isDeleting: false,
        notifications: null,
        language: null,
    },
    getters: {
        areNotificationsLoaded(state)
        {
            return state.notifications !== null;
        },
        isProcessing(state)
        {
            return state.isLoading || state.isSaving || state.isDeleting;
        },
        createNotification()
        {
            return (language) => ({
                type: "info",
                title: "",
                content: "",
                language: language
            })
        },
    },
    mutations: {
        setIsLoading(state, isLoading)
        {
            state.isLoading = isLoading;
        },
        setIsSaving(state, isSaving)
        {
            state.isSaving = isSaving;
        },
        setIsDeleting(state, isDeleting)
        {
            state.isDeleting = isDeleting;
        },
        setNotifications(state, notifications)
        {
            state.notifications = notifications;
        },
        setLanguage(state, language)
        {
            state.language = language;
        },
        addNotification(state, notification)
        {
            state.notifications.push(notification);
        },
        updateNotification(state, notification)
        {
            state.notifications = state.notifications.map(a => a.id === notification.id ? notification : a);
        },
        removeNotification(state, notification)
        {
            state.notifications = state.notifications.filter(a => a.id !== notification.id);
        },
    },
    actions: {
        load({ commit }, language)
        {
            commit('setIsLoading', true);
            commit('setLanguage', language);

            return notificationApi.index(language)
                .then(notifications => {
                    commit('setNotifications', notifications);
                }).catch(error => {
                    commit('setNotifications', null);
                    commit('setLanguage', null);
                }).finally(() => {
                    commit('setIsLoading', false);
                });
        },
        save({ commit }, notification)
        {
            commit('setIsSaving', true);

            if(notification.id === undefined)
            { // new Notification -> create it
                return notificationApi.store(notification)
                    .then(notification => {
                        commit('addNotification', notification);
                    }).finally(() => {
                        commit('setIsSaving', false);
                    });
            }
            else
            { // existing notification -> update it
                return notificationApi.update(notification)
                    .then(notification => {
                        commit('updateNotification', notification);
                    }).finally(() => {
                        commit('setIsSaving', false);
                    });
            }
        },
        delete({ commit }, notification)
        {
            commit('setIsDeleting', true);

            return notificationApi.destroy(notification)
                .then(notification => {
                    commit('removeNotification', notification);
                }).finally(() =>
                {
                    commit('setIsDeleting', false);
                })
        }

    }
}
